module.exports = __webpack_public_path__ + "static/media/EditIcon.d251a88d.svg";